// src/components/HomeView.js
import React from "react";
import { Link } from "react-router-dom";

function HomeView() {
  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h1>HOTHREAT</h1>
      <p></p>
      <ul style={{ listStyle: "none", padding: 0 }}>
        <li style={{ margin: "10px 0" }}>
          <Link to="/hotel/2/ee8bf7ab-2dbe-4206-9239-9a09e930963d/hotel_tres_torres/tfloors" style={{ color: "#007bff", textDecoration: "none" }}>
            Przejdź do widoku pięter
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default HomeView;
